export enum QuestionnaireStepStatusEnum {
    Incomplete = 1,
    PartiallyComplete = 2,
    Complete = 3
}